/**
* @ComponentFor Avensia.Shop.Features.Cms.Blocks.InfoBlock.InfoBlockViewModel
*/
import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
import MyMenigoIcon from './../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
class InfoBlock extends React.Component {
    getTypeStyle() {
        switch (this.props.color) {
            case 'RedLight':
                return styles.infoType;
            case 'GreenLight':
                return styles.tipsType;
            case 'BackgroundDark':
                return styles.reportType;
            default:
                return '';
        }
    }
    render() {
        return (React.createElement("div", { className: classnames(styles.base, this.getTypeStyle()) },
            React.createElement("div", { className: styles.iconRow }, !!this.props.iconName && (React.createElement(MyMenigoIcon, { name: this.props.iconName }))),
            !!(this.props.image) &&
                React.createElement("div", { className: classnames(styles.aspectRatio) },
                    React.createElement("img", { src: this.props.image })),
            React.createElement("h3", { className: styles.preamble }, this.props.name),
            React.createElement("p", { className: classnames(styles.description, styles.descriptionColor) }, this.props.body),
            !!this.props.ctaUrl && (React.createElement("div", { className: styles.cta },
                React.createElement("div", { className: styles.linkCol },
                    React.createElement("a", { className: styles.preamble, href: this.props.ctaUrl, target: this.props.ctaIsExternal === true || this.props.ctaIsFile === true ? '_blank' : '' }, this.props.ctaText)),
                React.createElement("div", { className: styles.iconCol }, !!this.props.ctaIconName && (React.createElement(MyMenigoIcon, { name: this.props.ctaIconName })))))));
    }
}
export default InfoBlock;
